import { defineStore } from 'pinia';
import { useEntityModelDetailStore } from './entity-model-detail.store';

export enum EntityModelEditType {
    EntityModel,
    EntityAttribute,
    CodeListAttributeMapping,
}
export interface EntityModelEditStoreState {
    create?: {
        type?: EntityModelEditType;
    };
    edit?: {
        key?: number;
        type?: EntityModelEditType;
    };
}

export const useEntityModelEditStore = defineStore('configuration-entity-model-edit-store', {
    state: (): EntityModelEditStoreState => ({
        create: null,
        edit: null,
    }),
    getters: {
        canEdit(): boolean {
            return useEntityModelDetailStore().isDraft;
        },
        isCreate(): (type: EntityModelEditType) => boolean {
            return (type: EntityModelEditType) => this.create?.type === type;
        },
        creating(): boolean {
            return this.create !== null && this.create?.type !== null;
        },
        isEdit(): (type: EntityModelEditType, id: number) => boolean {
            return (type: EntityModelEditType, id: number) => this.edit?.type === type && this.edit?.key === id;
        },
        editing(): boolean {
            return this.edit !== null && this.edit?.type !== null && this.edit?.key !== null;
        },
    },
    actions: {
        init(){
            this.create = null;
            this.edit = null;
        },
        openCreate(type: EntityModelEditType) {
            this.create = { type };
            this.edit = null;
        },
        closeCreate() {
            this.create = null;
        },
        openEdit(type: EntityModelEditType, key: number) {
            this.edit = { type, key };
            this.create = null;
        },
        closeEdit() {
            this.edit = null;
        },
    },
});
